var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6340_380243)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#F0F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6667 125.856C78.5873 132.079 73.4767 136.793 63.3333 139.856C75.5553 148.745 87.778 155.856 100 155.856C112.222 155.856 124.445 148.745 136.667 139.856C126.592 136.789 121.481 132.212 121.333 126.123C121.333 125.037 121.405 101.193 121.451 90.7894C131.005 78.4047 127.495 63.8854 124.501 64.2474C120.831 64.6947 89.0287 34.516 82.9287 32.9687C76.8287 31.4214 61.3333 36.4167 58.6667 50.3334C56 64.25 54.8853 99.3287 65 113.333C67.878 117.319 72.4793 118.867 78.6667 118C78.6753 120.913 78.6667 125.856 78.6667 125.856Z",
    fill: "url(#paint0_linear_6340_380243)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6667 118C93.3333 116.333 102.667 110 102.667 110C102.667 110 94.6667 123.333 78.6667 126V118Z",
    fill: "#DB6F3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.333 91C130.927 79.9534 149.333 57.4554 133.467 43.4554C128.133 17.4554 98.6667 20.3334 79 26.3334C65.782 30.366 55.8 38.3334 53.6667 32.3334C40.3333 43.4554 47.0107 54.3334 55.8 57.4554C63.7773 60.2887 77.2667 63.122 100.204 60.4554C104.301 59.9787 103.443 72.5274 105.633 73.884C108.917 75.9194 111.467 63.122 120.472 66.9647C129.477 70.8074 124.133 88.6247 114.467 88.6247C111.133 88.6247 109.467 97.7894 118.467 102.123C125 105.333 123.349 98.178 126.333 91Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 160.205C176.347 173.11 180 202.872 180 202.872H20C20 202.872 23.6547 173.107 30 160.205C36.3453 147.304 73.4 135.338 73.4 135.338C80.542 150 119.739 150 126.581 135.333C126.581 135.333 163.653 147.301 170 160.205Z",
    fill: "#B2BEC3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6340_380243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 135,
    width: 160,
    height: 68
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170 160.205C176.347 173.11 180 202.872 180 202.872H20C20 202.872 23.6547 173.107 30 160.205C36.3453 147.304 73.4 135.338 73.4 135.338C80.542 150 119.739 150 126.581 135.333C126.581 135.333 163.653 147.301 170 160.205Z",
    fill: "#DFE6E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6340_380243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 189.333V184H186.667V189.333H13.3333ZM13.3333 176V170.667H186.667V176H13.3333ZM13.3333 162.667V157.333H186.667V162.667H13.3333Z",
    fill: "#DFE6E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6340_380243",
    x1: 96.7478,
    y1: 32.6981,
    x2: 96.7478,
    y2: 155.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6340_380243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser21);
export default __webpack_public_path__ + "static/media/user-21.c8d23342d4fcbcd7d21f43e133ea0c74.svg";
export { ForwardRef as ReactComponent };